import React, { useEffect, useState } from 'react'
import UserLayout from '../../../components/layouts/UserLayout'
import Loader from '../../../components/elements/Loader';
import { useNavigate, useParams } from 'react-router-dom';
import ArrowIcon from '../../../components/elements/icons/ArrowIcon';
import { authHeader, transactionTimeStamp, userDetails } from '../../../utils';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { ERROR } from '../../../store/types';
import InlinePreloader from '../../../components/elements/InlinePreloader';
import { fetchPayments } from '../../../store/actions/paymentsActions';
import moment from 'moment';
import Checkbox from '../../../components/elements/form/Checkbox';

const AdmissionDetails = () => {
  const [admission, setAdmission] = useState(null);
  const [loading, setLoading] = useState(true);
  const { admissionId } = useParams()
  const [processing, setProcessing] = useState(false);
  const dispatch = useDispatch()
  const paymentsSelector = useSelector((state => state.payments))
  const navigate = useNavigate()
  const user = userDetails()
  useEffect(() => {
    const fetchAdmission = async () => {
      try {
        setLoading(true)
        const headers = authHeader()

        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/admissions/${admissionId}?expand=fee,academicSession`, { headers })            

        setAdmission(response.data.data)
        if(response.data.data.fee){
          dispatch(fetchPayments(`fee=${response.data.data.fee._id}&applied=false`))
        }

        setLoading(false)
      } catch (error) {
        console.log(error)
        dispatch({
            type: ERROR,
            error
        })
        setLoading(false)
      }
    }
    fetchAdmission()

    return () => {
      
    };
  }, [admissionId, dispatch]);

  const initializePayment = async () => {

    if(!acceptedTerms) {
      dispatch({
        type: ERROR,
        error: {response: {data: {
            message: 'Please accept the admissions policy before you proceed'
        }}}
      })
      return 
    }
    
    try {
      const headers = authHeader()
      console.log('==> ', admission)
      const paymentPayload = {
        fee: admission?.fee._id,
        paymentChannel: "ONLINE",
        redirectUrl: `${window.location.origin}/user/verify-payment?admission=${admissionId}`
      }
      setProcessing(true)
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/payments/initialize-payment`, paymentPayload, { headers })           
      console.log(response.data)
      window.location.href = response.data.data.link

      setLoading(false)
    } catch (error) {
      console.log(error)
      setProcessing(false)
      dispatch({
          type: ERROR,
          error
      })
      setLoading(false)
    }
  }

  const proceedToApplication = () => {
    if(!acceptedTerms) {
      dispatch({
        type: ERROR,
        error: {response: {data: {
            message: 'Please accept the admissions policy before you proceed'
        }}}
      })
      return 
    }

    navigate(`/user/applications/new-application/${admissionId}`)
  }

  const [acceptedTerms, setAcceptedTerms] = useState(false);

  return (
    <UserLayout>
    {loading ? 
      <Loader />
      :
      <div className='mt-5 w-full lg:w-9/12 2xl:w-1/2 mx-auto bg-gray-100 px-8 py-12'>
        <p className='tracking-[0.2em] uppercase mb-2'>{admission?.title} - {admission?.type}</p>
        <p className='text-sm'>Entry Classes: <span className='font-[550]'>{admission?.entryClasses.join(', ')}</span></p>
        <p className='text-sm'>Application Fee: <span className='capitalize text-gray-600 text-lg'>₦{(admission?.fee?.amount/100 || 0).toLocaleString()} </span></p>
        <p className='text-sm'>Open from <span className='font-[550]'>{transactionTimeStamp(admission?.startDate).date}</span> to  <span className='font-[600]'>{transactionTimeStamp(admission?.endDate).date}</span></p>
        <div className='p-2 rounded bg-vcm-light-purple bg-opacity-15 my-3 w-max'>
          <p className='text-sm text-vcm-purple'>The Academic year starts in <span className='font-[600] text-vcm-purple'>{moment(admission?.academicSession.startDate).format('MMMM')}, {moment(admission?.academicSession.startDate).format('YYYY')}</span></p>
        </div>

        <p className='text-sm underline mt-2 mb-1 uppercase'>Required Documents</p>
          <div className='flex items-start gap-x-1 my-2'>
            <div className='w-[20px]'>
              <p className='text-sm text-gray-400'>1</p>
            </div>
            <div>
              <p  className='text-sm mb-1'>
                Passport Photograph
              </p>
              <p className='text-sm text-gray-500'>
                A soft copy of the applicant's passport photograph.
              </p>
            </div>
          </div>
        {admission?.requiredDocuments.map((doc, docIndex)=>(
          <div key={docIndex} className='flex items-start gap-x-1 my-2'>
            <div className='w-[20px]'>
              <p className='text-sm text-gray-400'>{docIndex + 2}</p>
            </div>
            <div>
              <p  className='text-sm mb-1'>
                {doc.name} {!doc.required && <span className='text-[10px] ml-[10px] px-2 py-1 uppercase text-green-800 bg-green-400 bg-opacity-20'>optional</span>}
              </p>
              <p className='text-sm text-gray-500'>
                {doc.description}
              </p>
            </div>
          </div>
        ))}

        <div className='mt-12'>
          <h3 className='text-md font-[550] underline'>Vaatia College Makurdi Admissions Policy</h3>

          <p className='mt-[20px] text-sm'>The purpose of the Admissions Policy is to ensure that the admissions process is consistent and fair to all applicants. The policy is regularly monitored and reviewed and may be subject to change. The Principal of the College has overall responsibility for admissions and the operation of this policy. Details of the assessment process, and deadlines for application, are available on the College website www.vaatiacollege.com.ng or from the Admissions Office.</p>
          
          <p className='mt-[20px] text-sm'>The College selects for entry those children who have the potential to benefit from the education the College offers, and who meet the “Criteria for entry”, outlined below.</p>
          <p className='mt-[20px] text-sm font-[500]'>Criteria for entry</p>

          <p className='mt-[20px] text-sm'>Admission into Vaatia College is based on academic merit which is evaluated through an entry examination and may be granted when the following criteria are met: </p>
          <p className='mt-[10px] ml-[20px] text-sm'>1. The applicant achieves a result (an average of 60% and above) in the entrance assessment which, in the professional judgment of the principal, indicates that they possess aptitude and ability that are consistent with the academic requirements of the College. </p>
          <p className='mt-[10px] ml-[20px] text-sm'>2. Vaatia College admits students from the age of 10, 11 and 13 years into the JSS I. JSS 2 and SSS 1 classes respectively except in exceptional cases.</p>
          <p className='mt-[10px] ml-[20px] text-sm'>3. References from the candidate’s previous school are provided.</p>
          <p className='mt-[10px] ml-[20px] text-sm'>4. The College is fully able to meet the educational and other relevant needs of the applicant.</p>
          <p className='mt-[10px] ml-[20px] text-sm'>5. The cost of college fees and other expenses can be met on the applicant’s behalf.</p>
          <p className='mt-[10px] ml-[20px] text-sm'>6. There is an available place for the applicant.</p>

          <div className='w-full mt-12'>
            <Checkbox
              CheckboxLabel="I have read and agree with the Admission Policy of Vaatia College Makurdi"
              // checkboxToggleFunction={()=>{setOverrideKycName(!overrideKycName)}} 
              checkboxToggleFunction={()=>{
                  setAcceptedTerms(!acceptedTerms)
              }} 
              isChecked={acceptedTerms} 
              hasError={false} 
            />
          </div>


        </div>

        {user.userType === 'USER' && (paymentsSelector?.payments?.payments?.length > 0 || !admission?.fee)
          ?
            <button onClick={()=>{proceedToApplication()}} className='p-3 bg-vcm-purple border border-vcm-purple text-purple-100 rounded-md mt-5 text-sm flex flex-row items-center gap-x-3 hover:text-vcm-purple hover:bg-vcm-light-purple transition duration-200'>
              Apply for this opening <ArrowIcon className={`w-4 h-4`} />
            </button>
          :
            <button onClick={()=>{initializePayment()}} disabled={!acceptedTerms || processing} className='p-3 disabled:bg-opacity-50 disabled:border-opacity-20 disabled:cursor-not-allowed bg-vcm-purple border border-vcm-purple text-purple-100 rounded-md mt-5 text-sm flex flex-row items-center gap-x-3 hover:text-vcm-purple hover:bg-vcm-light-purple transition duration-200'>
              {!processing ? <>
                Make payment and begin application <ArrowIcon className={`w-4 h-4`} />
              </> : 
                <InlinePreloader />
              }
            </button>
        }
      </div>
    }
    </UserLayout>
  )
}

export default AdmissionDetails